import { useMemo } from 'react'
import useRestrictedCancellationView from 'hooks/useRestrictedCancellationView'
import type { RestrictedCancellationPolicyView } from 'hooks/useRestrictedCancellationView'
import { getRestrictedCancellationSplit } from 'lib/offer/cancellationPolicyUtils'

interface UseRestrictedPropertyCancellationPolicyOptions {
  canActivate?: boolean
}

function useRestrictedPropertyCancellationPolicy(
  headlineCancellationPolicyStart: Date | undefined,
  propertyTimeZone: string,
  eligible: boolean,
  controlDescription: Array<string | undefined>,
  options?: UseRestrictedPropertyCancellationPolicyOptions,
): RestrictedCancellationPolicyView | undefined {
  const split = useMemo(() => {
    if (!eligible || !headlineCancellationPolicyStart) return undefined
    return getRestrictedCancellationSplit(headlineCancellationPolicyStart, propertyTimeZone, new Date())
  }, [eligible, headlineCancellationPolicyStart, propertyTimeZone])

  return useRestrictedCancellationView(split, controlDescription, { canActivate: options?.canActivate })
}

export default useRestrictedPropertyCancellationPolicy
